import task from '@/components/suppliers/task/storage';
import taskList from '@/components/suppliers/taskList/storage';
import archiveList from '@/components/suppliers/archiveList/storage';
import excludedSites from '@/components/suppliers/excludedSites/storage';
import keys from '@/components/suppliers/keys/storage';
import stopWords from '@/components/suppliers/stopWords/storage';
import viewTask from '@/components/suppliers/viewTask/storage';

export default {
    namespaced: true,
    modules: {
        task,
        taskList,
        archiveList,
        excludedSites,
        keys,
        stopWords,
        viewTask,
    },
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    }
}